import { useCallback } from 'react';

import {
  SalesforceConnection,
  SalesforceConnectionType,
} from '@modules/salesforce/models';

import {
  SalesforceMetadataSyncResultsService,
  SalesforceConnectionsService,
} from '@modules/salesforce/services/index';

const useCleanUpOrphanConnection = () => {
  const cleanupOrphanConnection = useCallback(
    async (connection: SalesforceConnection) => {
      const connectionId = connection?.id;
      const connectionType = connection?.connectionType;

      if (
        connectionId &&
        connectionType === SalesforceConnectionType.METADATA
      ) {
        try {
          const query = `,salesforceConnectionId:${connectionId},metadataSyncResult:SUCCESS,metadataSyncType:INITIAL_SYNC`;
          const sort = 'id,desc';
          const result: any =
            await SalesforceMetadataSyncResultsService.findAll(
              query,
              undefined,
              undefined,
              sort,
            );

          if (!result?.content?.length) {
            await SalesforceConnectionsService.remove(connectionId);
            return true;
          }
        } catch (err: any) {
          return false;
        }
      }
    },
    [],
  );

  return { cleanupOrphanConnection };
};

export { useCleanUpOrphanConnection };
